import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FuiModalService } from 'ngx-fomantic-ui';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';


import { OldAppModal } from '../../shared/components/modals/old-app/old-app.component';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { ToasterService } from '../../shared/services/toaster.service';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  constructor(
    private readonly authService: AuthService,
    private readonly modalService: FuiModalService,
    private readonly router: Router,
    private readonly toasterService: ToasterService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          switch (error.status) {

            case HttpStatusCode.NotFound:
              if (error.error.error==='OLD_APP_VERSION') {
                this.modalService.open(new OldAppModal()).onApprove(() => {
                  location.reload();
                })
              }
              break;

            case HttpStatusCode.InternalServerError:
              if (req.url==="/api/prl/structureMembers/me") {
                this.router.navigate(['/mySpace/account/register']);
                this.toasterService.show('Utilisateur inconnu.');
              }
              break;
    
            case HttpStatusCode.Unauthorized:
              if (req.url==="/api/prl/structureMembers/me") {
                this.authService.isAuthenticated.subscribe((isAuthenticated: boolean)=> {
                  if(isAuthenticated) {
                    setTimeout(() => {
                      // Keycloak session over. Refreshing page to get back to Keycloak login page
                      this.toasterService.show('Votre session a expiré. Veuillez vous reconnecter.');
                      this.authService.purgeAuth();
                      this.router.navigate(['/']);
                    }, 1000);
                  }
                });
              } else {
                this.authService.populate();
              }
              break;
          }
        }
        return throwError(() => error.error?.message ?? error.statusText);
      })
    );
  }
}
